import {
  NavBarList,
  NavBarItem,
  NavAnchor,
  NavRouterLink,
  NavLinksColumn,
  CTALinksColumn,
} from './styled';
import { CTA } from './CTA';
import { ROUTE_CAREERS, ROUTE_ABOUT } from '@/constants/routes';
import { useHomeRoute } from '@/hooks/useHomeRoute';

interface Props {
  isWhite?: boolean;
}

export const Links = ({ isWhite }: Props) => {
  const homeRoute = useHomeRoute();
  return (
    <>
      <NavLinksColumn
        col={6}
        displayFlex
        alignItem="center"
        justifyContent="flex-start"
      >
        <NavBarList>
          <NavBarItem>
            <NavRouterLink to={{ type: homeRoute }} $isWhite={isWhite}>
              Home
            </NavRouterLink>
          </NavBarItem>
          <NavBarItem>
            <NavRouterLink to={{ type: ROUTE_ABOUT }} $isWhite={isWhite}>
              About Us
            </NavRouterLink>
          </NavBarItem>
          <NavBarItem>
            <NavAnchor href="/plans" $isWhite={isWhite}>
              Plans
            </NavAnchor>
          </NavBarItem>
          <NavBarItem>
            <NavRouterLink to={{ type: ROUTE_CAREERS }} $isWhite={isWhite}>
              Careers
            </NavRouterLink>
          </NavBarItem>
        </NavBarList>
      </NavLinksColumn>
      <CTALinksColumn
        col={4}
        displayFlex
        alignItem="center"
        justifyContent="flex-end"
      >
        <NavBarList>
          <CTA isWhite={isWhite} />
        </NavBarList>
      </CTALinksColumn>
    </>
  );
};
